import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-grievance-approval-level',
  templateUrl: './grievance-approval-level.component.html',
  styleUrls: ['./grievance-approval-level.component.scss']
})
export class GrievanceApprovalLevelComponent implements OnInit {
  GrievanceLvlForm: FormGroup;
  departmentList: any;
  filterdepartmentList: any;
  userPermission: any;
  UserCollege
  CourseList: any;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  filteredRoleList: any;
  RoleList: any;
  dialogRef: MatDialogRef<any>;
  userList: any;
  filteredUserList: { [index: number]: any[] } = {};
  rowsCount: any;
  AssLvl: FormArray;
  arr: any;
  lvl = 0;
  CoCode = 0;
  LvlArray: FormArray;
  submitpayload: any;
  APIService: string;
  assignTableData: any[];
  Table = false;
  errMsg: any;
  constructor(public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService, 
    private httpClient: HttpClient,
  ) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    this.lvl = 0;
    this.arr = [];
    this.CoCode = 0;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.getDepartment();
    this.fetchCourse();
    // this.getCourse();
    // this.getCollegeData();
    this.fetchRole();
    this.fetchUser();
    this.Table = false;
    this.GrievanceLvlForm = this.fb.group({
      DepartmentName: new FormControl ('',[Validators.required]),
      course: new FormControl ('',[Validators.required]),
      college: new FormControl ('',[Validators.required]),
      LvlArray: new FormArray([]),  
    });
    // this.addNewRow()
  }
  getDepartment() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDepartment(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.departmentList = res.data;
        this.filterdepartmentList = this.departmentList.slice();
      } else {
        
      }
    });
  }

  fetchCourse() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    const payload = {};
    this.collegeList = [];
    this.spinner.show();
    payload['LoginId'] = 0;
    payload['CgCode'] = this.UserCollege
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        // this.spinner.hide();
      }
    },);
  }
  getClg(CoCode) {
    this.spinner.show();
    this.Table = false;
    this.CoCode = CoCode;
    this.collegeList = [];
    const payload = {};
    payload['CoCode'] = CoCode
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      if(res.status){
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        // this.ApplyFee.controls['college'].setValue('')
        this.spinner.hide()
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  // getCollegeData() {
  //   if(this.userPermission[0].CgUi == 'C'){
  //     this.UserCollege= this.userPermission[0].CgId;
  //   }
  //   else{
  //     this.UserCollege = ''
  //   }
  //   this.spinner.show();
  //   const payload = {};
  //   payload['CgCode'] = this.UserCollege
  //   this.umsService.getCollege(payload).subscribe((res) => {
  //     this.spinner.hide();
  //     this.collegeList = res.data;
  //     this.filteredCollegeList = this.collegeList.slice();

  //   }, (ERROR: HttpErrorResponse) => {
  //     this.collegeList = [];
  //     this.spinner.hide();
  //   })
  // }


  fetchRole() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ROLE';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.RoleList = res.data;
        this.filteredRoleList = this.RoleList.slice();
      } else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  
  fetchUser() {
    this.spinner.show();
    let payload = {};
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      this.userList = [];
      if (res.status) {
        this.userList = res.data;
        this.filteredUserList = this.userList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  getLvlArrayControls() {
    return (this.GrievanceLvlForm.get('LvlArray') as FormArray).controls;
  }
  addNewRow() {
  //   const newRowIndex = this.rowsCount; // Or however you determine the new row index
  // this.filteredUserList[newRowIndex] = this.userList.slice();
  // this.rowsCount++;
    this.lvl = this.GrievanceLvlForm.controls.LvlArray.value.length
    const creds = this.GrievanceLvlForm.controls.LvlArray as FormArray;
    creds.push(
      this.fb.group({
        Role: new FormControl ('',[Validators.required]),
        UserId:new FormControl ('',[Validators.required]),
        AssignLevel: new FormControl(this.lvl + 1),
      })
    );
  }

  addNewRow2() { //this function is called to add new row when clicked on add button
    const newRowIndex = this.rowsCount; // Or however you determine the new row index
  this.filteredUserList[newRowIndex] = this.userList.slice();
  this.rowsCount++;
    this.arr = this.GrievanceLvlForm.controls.LvlArray.value
    this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
    if (this.LvlArray.invalid) {
      this.LvlArray.controls.forEach(element => {
        element.get('UserId').markAsTouched();
        element.get('Role').markAsTouched();
      })
    }
    else{
      this.lvl = this.GrievanceLvlForm.controls.LvlArray.value.length
      const creds = this.GrievanceLvlForm.controls.LvlArray as FormArray;
      creds.push(
        this.fb.group({
          Role: new FormControl ('',[Validators.required]),
          UserId:new FormControl ('',[Validators.required]),
          AssignLevel: new FormControl(this.lvl + 1),
        })
      );
    }
  }
  deleteRow(index){
    if(index !== 0){
      (<FormArray>this.GrievanceLvlForm.get("LvlArray")).removeAt(index);
      this.arr = this.GrievanceLvlForm.controls.LvlArray.value
      this.lvl = this.GrievanceLvlForm.controls.LvlArray.value.length
      const index1 = this.lvl - 1
      const data = this.GrievanceLvlForm.controls.LvlArray.value
      data.forEach((element,i) => {
        this.AssLvl = this.GrievanceLvlForm.get('LvlArray') as FormArray;
        // this.AssLvl.at(i).get('FinalApproval').setValue(false);
        // if(index1 == i){
        //   this.AssLvl.at(i).get('FinalApproval').setValue(true);
        // }
      });
      // delete this.filteredUserList[index];
      // this.rowsCount--;
    }
    else{
      let  data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    
    }
    
  }
  submit(){
    this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
    if (this.LvlArray.invalid) {
      this.LvlArray.controls.forEach(element => {
        element.get('UserId').markAsTouched();
        element.get('Role').markAsTouched();
      })
    }
    if (this.GrievanceLvlForm.invalid) {
      this.GrievanceLvlForm.get('course').markAsTouched();
      this.GrievanceLvlForm.get('college').markAsTouched();
      this.GrievanceLvlForm.get('DepartmentName').markAsTouched();
      return;
    } else {
       
      this.AddAssignLevel();
    }
  }
  deletedata(id) {
    this.spinner.show();
    
  }
  AddAssignLevel() {
    this.spinner.show();
    this.submitpayload = this.GrievanceLvlForm.value;
    let abcd = this.GrievanceLvlForm.get('LvlArray') as FormArray;
    let payload = abcd.value;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        CoCode: this.submitpayload.course,
        CgCode: this.submitpayload.college,
        DepartmentName: this.submitpayload.DepartmentName,
        Role: payload[0]['Role'],
        UserId: payload[0]['UserId'],
        AssignLevel: payload[0]['AssignLevel'],
      },
    };
    this.httpClient
      .delete(this.APIService + '/admin/GrievanceAssign', options)
      .subscribe((s) => {
        this.spinner.hide();
       
        // this.AddData();
        const cc = [];
        cc.push(s);
        if(cc[0]['status'] == true){
          const data = {};
         
            this.AddData();
         
        }
        else if(cc[0]['status'] == false){
          const data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
       
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      });
  }

  AddData(){
    this.submitpayload = this.GrievanceLvlForm.value;
    let abcd = this.GrievanceLvlForm.get('LvlArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array)=> {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            CoCode: new FormControl(this.submitpayload.course),
            CgCode: new FormControl(this.submitpayload.college),
            DepartmentName: new FormControl(this.submitpayload.DepartmentName),
            Role: new FormControl(element.Role),
            UserId: new FormControl(element.UserId),
            AssignLevel: new FormControl(element.AssignLevel),
          })
        )
       this.umsService.addGrievanceAssign(arr1[0].value).subscribe(res => {
        if (res.status == false){
          iserror = true;
          this.errMsg = res.message
        } 
        if (index === array.length -1) resolve(); 
        else {
          // iserror = false
          this.errMsg = res.message
        }
      }, (ERROR: HttpErrorResponse) => {
        iserror = true;
        this.errMsg = ERROR.error.message
        if (index === array.length -1) resolve();
       });
      });
    })
    bar.then(() => {
      if(iserror == false){
        let  data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      else{
        let  data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    });
  }

  prepopulation(id) {
    this.arr = id
    this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.clear();
    this.assignTableData = [];
    if (id.length == 0) {
      this.Table = true;
      this.addNewRow();
      // this.LvlArray.clear();
    } else {
      this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.clear();
      id.forEach((element,index) => {
        this.addNewRow();
      });
      this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
      this.assignTableData = Object.values(id);
      this.assignTableData.sort((a, b) => parseInt(a.AssignLevel) - parseInt(b.AssignLevel));
      this.assignTableData.forEach((element, i) => {
        this.LvlArray.at(i).get('Role').setValue(element.Role);
        this.LvlArray.at(i).get('UserId').setValue(element.UserId);
        this.LvlArray.at(i).get('AssignLevel').setValue(element.AssignLevel);
      });
      const data = this.GrievanceLvlForm.controls.LvlArray.value
      data.forEach((element,index) => {
        if(element.Role == '' && element.UserId == ''){
          (<FormArray>this.GrievanceLvlForm.get("LvlArray")).removeAt(index);
        }
      });
    } 
  }
  
  getAssign(id){
    this.spinner.show();
    this.submitpayload = this.GrievanceLvlForm.value
    this.Table = false;
    const payload = {};
    payload['CoCode'] =  this.submitpayload.course;
    if(id.CoCgCgCode == undefined){
      payload['CgCode'] =  this.submitpayload.college;
    }
    else{
      payload['CgCode'] =  id.CoCgCgCode;
    }
    payload['DepartmentName'] =  this.submitpayload.DepartmentName;
    this.umsService.getGrievanceAssign(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Table = true;
        this.prepopulation(res.data)
      } else{
        this.spinner.hide()
        this.prepopulation(res.data)
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  UserData(user,i){ 
    //this function is called to check whether selected user is mapped in supervisor for course as if not mapped then it will create problem in further flow
    this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
    // let isPopupShown = false;
    this.arr.forEach(element => {
      if(element.UserId == user){
        let data = {};
      data['message'] = 'User Already Assigned';
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.LvlArray = this.GrievanceLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.at(i).get('UserId').setValue('');
      }
      else{
        this.arr = this.GrievanceLvlForm.controls.LvlArray.value
        
      }
    });
    
  }
  isOptionDisabled(loginId: string,i): boolean {
    this.arr = this.GrievanceLvlForm.controls.LvlArray.value
    const selectedUserId = this.arr[i]['UserId'];
    return selectedUserId === loginId;
}
}
